import produce from 'immer'
import Actions from '../actions'

const initialState = {
  isCallActive: false,
  accessToken: null,
  roomName: null,
  appointment: null,
  isVideoPromptVisible: false,
  otherVideoParticipant: null,
  isZoom: true,
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.VIDEO_CALL_STATUS_CHANGED: {
      draft.isCallActive =
        payload?.status === 'connecting' || payload?.status === 'connected'
      break
    }
    case Actions.VIDEO_CALL_DIALOG_VISIBLE: {
      draft.isVideoPromptVisible = payload
      break
    }
    case Actions.GET_OTHER_PARTICIPANT: {
      draft.otherVideoParticipant = payload
      break
    }
    case Actions.ASK_NICELY_SLUG_RECEIVED: {
      draft.isCallActive = false
      draft.accessToken = null
      draft.roomName = null
      draft.appointment = null
      draft.isVideoPromptVisible = false
      draft.otherVideoParticipant = null
      break
    }
    case Actions.VIDEO_CALL_INITED: {
      const data = payload?.data
      draft.accessToken = data?.accessToken
      draft.roomName = data?.roomName
      draft.isZoom = data?.isZoom
      draft.appointment = data?.appointment
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
